import { FC, ReactElement } from 'react';

import { Logo } from '../../components';

import './LogoList.scss';

interface LogoListProps {
    logos: string[];
    className?: string;
}

const LogoList: FC<LogoListProps> = ({ logos, className = '' }): ReactElement => (
    <ul className={`logo-list ${className}`}>
        {logos.map(logo => (
            <li key={logo} className="logo-list__item">
                <Logo name={logo} className="logo-list__logo" />
            </li>
        ))}
    </ul>
);

export default LogoList;
